export default "__VITE_ASSET__597fd3b3__"